import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">深度追踪 · 全景呈现</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item, idx) => (
            <article key={idx} className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-[10px] font-semibold whitespace-nowrap">
                    {item.label}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{item.updateTime}</span>
                  <span className="text-xs text-primary-600 font-medium whitespace-nowrap">查看专题 &rarr;</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}